import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function VerificationMetrics() {
  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle>Verification Status</CardTitle>
      </CardHeader>
      <CardContent className="flex items-center justify-center min-h-[150px]">
        <p className="text-muted-foreground text-sm text-center">
          Cross-cipher verification rollups arrive with the user-wide
          aggregate endpoint in Phase 06.
        </p>
      </CardContent>
    </Card>
  );
}
